const INFO_USER_LOCALSTORAGE = 'mage-cache-storage';
const CONTACT_REP_ALLOWED_GROUPS = 'contact-rep-allowed-groups';

export const TIER_13_GROUP_ID = 13;

export const getUserAttributes = () => {
  return (
    JSON.parse(localStorage.getItem(INFO_USER_LOCALSTORAGE) || '{}')
      ?.customer || {}
  );
};

export const getInboxAttributes = () => {
  return (
    JSON.parse(localStorage.getItem(INFO_USER_LOCALSTORAGE) || '{}')?.inbox ||
    {}
  );
};

export const getUnreadMessagesCount = () => {
  return (
    JSON.parse(localStorage.getItem(INFO_USER_LOCALSTORAGE) || '{}')?.messages
      ?.messages?.length || 0
  );
};

export const getCartSummaryCount = () => {
  return (
    JSON.parse(localStorage.getItem(INFO_USER_LOCALSTORAGE) || '{}')?.cart
      ?.summary_count || 0
  );
};

export const getContactRepAllowedGroups = () => {
  return (
    JSON.parse(localStorage.getItem(CONTACT_REP_ALLOWED_GROUPS) || '[]') || []
  );
};

export const isCustomerAllowedToContactRep = () => {
  const customerData = getUserAttributes();
  const allowedGroups = getContactRepAllowedGroups();

  return (
    customerData &&
    allowedGroups.some((v: string) => +v === customerData.groupId)
  );
};

export const isCustomerFromGensler = () => {
  const customerData = getUserAttributes();

  return (customerData?.email || '').toLowerCase().includes('gensler.com');
};
